import React from "react";
import PropTypes from "prop-types";

import { shouldComponentUpdateGB } from "../../GB/NonComponents/GBUtil";

import * as SCConst from "../NonComponents/SCConst";
import {
    getAllSitesIncluded,
    getSiteProvince,
    getSiteSNU,
    hasSitesToDisplay,
    SC_onCheckboxChange,
} from "../NonComponents/SCDataUtil";
import { SC_CreateCheckBox } from "../NonComponents/SCUtil";
import TCheckBoxLabel from "../../../Library/Labels/TCheckBoxLabel";
// import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
// import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";

class SCLocationsSelector extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        config: PropTypes.object,
        configExtra: PropTypes.object,
        //onConfigChange      : PropTypes.func,
        selectedCountryCode: PropTypes.number,
        countryObjList: PropTypes.any,
        siteInfo: PropTypes.object,
        mstIDsObj: PropTypes.object,
    };

    static defaultProps = {
        config: null,
        configExtra: null,
        //onConfigChange      : () => console.log('onConfigChange'),
        selectedCountryCode: 0,
        countryObjList: [],
        siteInfo: null,
        mstIDsObj: null,
    };

    /* Avoid re-rendering if we don't have to (if no props or state affect this form). */
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdateGB(this.props, nextProps, this.state, nextState);
    }

    //==================================================================================================================
    //
    //                                              Event Handlers
    //
    //==================================================================================================================

    onCheckboxChange = (checked, event, name, caption, info) => {
        try {
            const config = this.props.config;
            const configExtra = this.props.configExtra;
            const siteInfo = this.props.siteInfo;
            const countryObjList = this.props.countryObjList;
            const selectedCountryCode = this.props.selectedCountryCode;

            SC_onCheckboxChange(
                checked,
                event,
                name,
                caption,
                info,
                config,
                configExtra,
                siteInfo,
                countryObjList,
                selectedCountryCode,
                (config) => {
                    this.setState({
                        config: config,
                    });
                }
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onProvinceClick = (provCurrID) => {
        try {
            //const config = this.props.config;
            let configExtra = this.props.configExtra;

            /* If the same province was clicked, then close it by setting it to 0. */
            if (configExtra.openProvCurrID === provCurrID) {
                configExtra.openProvCurrID = 0;
            } else {
            /* Otherwise, open the new province. */
                configExtra.openProvCurrID = provCurrID;
            }

            this.forceUpdate();
            //this.props.onConfigChange(configDrawer, configExtraDrawer);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onSNUClick = (SNU_CurrID) => {
        try {
            //const config = this.props.config;
            let configExtra = this.props.configExtra;

            /* If the same SNU was clicked, then close it by setting it to 0. */
            if (configExtra.openSNU_CurrID === SNU_CurrID) {
                configExtra.openSNU_CurrID = 0;
            } else {
            /* Otherwise, open the new SNU. */
                configExtra.openSNU_CurrID = SNU_CurrID;
            }

            this.forceUpdate();
            //this.props.onConfigChange(configDrawer, configExtraDrawer);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    //==================================================================================================================

    /* "<" means the province is closed, so clicking on it will open its list of SNUs.
       Update the open province ID to the one we clicked on. */
    onProvinceLeftArrowClick = (provCurrID) => {
        try {
            //const config = this.props.config;
            let configExtra = this.props.configExtra;

            configExtra.openProvCurrID = provCurrID;

            this.forceUpdate();
            //this.props.onConfigChange(configDrawer, configExtraDrawer);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    /* ">" means the province is open, so clicking on it will close its list of SNUs.
       Set the open province ID to 0, since all provinces should now be closed. */
    onProvinceRightArrowClick = () => {
        try {
            //     const config = this.props.config;
            let configExtra = this.props.configExtra;

            configExtra.openProvCurrID = 0;
            configExtra.openSNU_CurrID = 0;

            this.forceUpdate();
            //this.props.onConfigChange(configDrawer, configExtraDrawer);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    /* "<" means the SNU is closed, so clicking on it will open its list of sites.
       Update the open SNU ID to the one we clicked on. The open province should
       remain unchanged. */
    onSNU_LeftArrowClick = (SNU_CurrID) => {
        try {
            //     const config = this.props.config;
            let configExtra = this.props.configExtra;

            configExtra.openSNU_CurrID = SNU_CurrID;

            this.forceUpdate();
            //this.props.onConfigChange(configDrawer, configExtraDrawer);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    /* ">" means the SNU is open, so clicking on it will close its list of sites.
       Set the open SNU ID to 0, since all SNUs should now be closed. */
    onSNU_RightArrowClick = () => {
        try {
            //     const config = this.props.config;
            let configExtra = this.props.configExtra;

            configExtra.openSNU_CurrID = 0;

            this.forceUpdate();
            //this.props.onConfigChange(configDrawer, configExtraDrawer);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onAllSitesCheckboxChange = (checked, event, name, caption, info) => {
        try {
            let config = this.props.config;
            //  const configExtra = this.props.configExtra;
            const siteInfo = this.props.siteInfo;

            const sitesIncluded = config[SCConst.sitesIncluded];

            const provCurrID = info[0];
            const SNU_CurrID = info[1];

            /* Make sure all sites associated with the same province and SNU are (un)checked. */
            for (let i = 0; i < sitesIncluded.length; i++) {
                if (getSiteProvince(siteInfo, i) === provCurrID && getSiteSNU(siteInfo, i) === SNU_CurrID) {
                    config[SCConst.sitesIncluded][i] = checked;
                }
            }

            this.forceUpdate();
            //this.props.onConfigChange(configDrawer, configExtraDrawer);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    createProvincesDiv = () => {
        try {
            let provDivArray = [];

            const config = this.props.config;
            const configExtra = this.props.configExtra;

            const provincesStr = config[SCConst.provincesStr];

            /* IMPORTANT: We have to allow the the user to (un)check ALL possible provinces EXCEPT for those
               which no sites are mapped to,  because (de)selecting them influences the  displayed sites. */
            for (let i = 0; i < provincesStr.length; i++) {
                // let keyboardArrow = null;
                let labelStyle = {};

                /* Add an arrow for every province except 'All' */
                if (i !== SCConst.all) {
                    if (configExtra.openProvCurrID === i) {
                        labelStyle = { cursor: "pointer", fontWeight: "bold", textDecoration: "underline" };
                        // keyboardArrow =
                        //     <KeyboardArrowRight
                        //         style={{cursor: 'pointer', float: 'right'}}
                        //         onClick={this.onProvinceRightArrowClick}
                        //         key={'ProvinceArrowRight' + i}
                        //     />;
                    } else {
                        labelStyle = { cursor: "pointer" };
                        // keyboardArrow =
                        //     <KeyboardArrowLeft
                        //         style={{cursor: 'pointer', float: 'right'}}
                        //         onClick={()=>this.onProvinceLeftArrowClick(i)}
                        //         key={'ProvinceArrowLeft' + i}
                        //     />;
                    }
                }

                const provCheckBox = SC_CreateCheckBox(
                    SCConst.provincesIncluded,
                    1,
                    i,
                    0,
                    provincesStr[i],
                    i,
                    config,
                    this.onCheckboxChange,
                    () => this.onProvinceClick(i),
                    labelStyle
                );

                /* Makes arrow appear next to checkbox. */
                const provCheckBoxClone = React.cloneElement(
                    provCheckBox,
                    { style: { display: "inline-block" } },
                    { key: "Province" + i }
                );

                provDivArray.push(
                    <div key={"provDivArray" + i}>
                        {provCheckBoxClone}
                        {/*{keyboardArrow}*/}
                    </div>
                );
            }

            return (
                <div
                    key={"provincesDiv"}
                    style={{
                        width: "33%",
                        float: "left",
                    }}
                >
                    <h5 key={"provincesDivH5"}>Province</h5>
                    {provDivArray}
                </div>
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    createSNUsDiv = (provCurrID) => {
        try {
            let SNUsDivArray = [];

            const config = this.props.config;
            const configExtra = this.props.configExtra;
            const siteInfo = this.props.siteInfo;

            /* 2d array by province and SNU. */
            const SNUsStr = config[SCConst.SNUsStr];

            /* 'All' provinces can't have a corresponding list of SNUs, so skip 0. */
            if (provCurrID !== 0) {
                /* IMPORTANT: We have to allow the user to (un)check ALL possible SNUs EXCEPT for those which
                   no sites are mapped to,  because (de)selecting them influences the displayed sites. HOWEVER, if
                   no sites are mapped to a particular province and SNU, we do not want to show a left or right arrow
                   because there will be sites to choose from. */
                for (let i = 0; i < SNUsStr[provCurrID].length; i++) {
                    // let keyboardArrow = null;
                    let labelStyle = {};
                    let isNotAll = i !== SCConst.all;
                    let hasSitesToShow = hasSitesToDisplay(config, siteInfo, provCurrID, i);

                    /* Add an arrow for every SNU to which at least one site has been mapped and can be displayed.
                       Ignore 'All' */
                    if (isNotAll && hasSitesToShow) {
                        if (configExtra.openSNU_CurrID === i) {
                            labelStyle = { cursor: "pointer", fontWeight: "bold", textDecoration: "underline" };
                            // keyboardArrow =
                            //     <KeyboardArrowRight
                            //         style={{cursor: 'pointer', float: 'right'}}
                            //         onClick={this.onSNU_RightArrowClick}
                            //         key={'SNUArrowRight' + i}
                            //     />;
                        } else {
                            labelStyle = { cursor: "pointer" };
                            // keyboardArrow =
                            //     <KeyboardArrowLeft
                            //         style={{cursor: 'pointer', float: 'right'}}
                            //         onClick={() => this.onSNU_LeftArrowClick(i)}
                            //         key={'SNUArrowLeft' + i}
                            //     />;
                        }
                    } else if (i !== SCConst.all) {
                        labelStyle = { cursor: "no-drop", color: "#BDBDBD" };
                    }

                    const SNU_CheckBox = SC_CreateCheckBox(
                        SCConst.SNUsIncluded,
                        2,
                        provCurrID,
                        i,
                        SNUsStr[provCurrID][i],
                        i,
                        config,
                        this.onCheckboxChange,
                        () => this.onSNUClick(i),
                        labelStyle
                    );

                    /* Makes arrow appear next to checkbox. */
                    const SNU_CheckBoxClone = React.cloneElement(
                        SNU_CheckBox,
                        { style: { display: "inline-block" } },
                        { key: "SNU" + i }
                    );

                    SNUsDivArray.push(
                        <div>
                            {SNU_CheckBoxClone}
                            {/*{keyboardArrow}*/}
                        </div>
                    );
                }
            }

            if (SNUsDivArray.length === 0) {
                SNUsDivArray = <h4>No SNU available</h4>;
            }

            return (
                <div
                    style={{
                        width: "33%",
                        float: "left",
                    }}
                >
                    <h5>SNU</h5>
                    {SNUsDivArray}
                </div>
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    createSitesDiv = (provCurrID, SNU_CurrID) => {
        try {
            const config = this.props.config;
            const siteInfo = this.props.siteInfo;

            const sitesStr = config[SCConst.sitesStr];
            const sitesDisplayed = config[SCConst.sitesDisplayed];
            //const provincesIncluded = config[SCConst.provincesIncluded];
            //const SNUsIncluded = config[SCConst.SNUsIncluded];
            let sitesDivArray = [];

            /* sitesDisplayed tells us if a site should be displayed based on the user's selected characteristics,
               provinces, and SNUs. The server normally populates this for us. However, we won't be querying the
               server for the configOptObj until the user clicks Save at the top of the Location drawer, so
               sitesDisplayed won't reflect changes to provinces and SNUs the user made in this drawer.
               Therefore, we need to check sitesDisplayed, provincesIncluded, AND SNUsIncluded to tell us if we
               should draw a site div for a site.
             */

            /* Add an 'All' checkbox. Done differently from provinces and SNUs because the desktop
               version does not save a separate 'All' status for included sites for each province and SNU. */
            const allChecked = getAllSitesIncluded(config, siteInfo, provCurrID, SNU_CurrID);
            let info = [];

            info.push(provCurrID);
            info.push(SNU_CurrID);

            const sitesIncludedAllCheckbox = (
                <TCheckBoxLabel
                    caption={"All"}
                    value={allChecked}
                    info={info}
                    onClick={this.onAllSitesCheckboxChange}
                    key={"sitesIncludedAll"}
                    style={{ height: "auto", margin: "margin: 0px 0px 0px 0px", display: "inline-block" }}
                    labelStyle={{ fontSize: 13 }}
                />
            );

            sitesDivArray.push(<div>{sitesIncludedAllCheckbox}</div>);

            for (let i = 1; i < sitesStr.length; i++) {
                if (
                    sitesDisplayed[i] &&
                    getSiteSNU(siteInfo, i) === SNU_CurrID &&
                    getSiteProvince(siteInfo, i) === provCurrID
                ) {
                    /* Pass sitesIncluded instead of sitesDisplayed, because we want the checkbox to be checked if
                       sitesIncluded is true. The sitesDisplayed array only controls if the site should be shown, not
                       whether it should be checked or not. */
                    const siteCheckBox = SC_CreateCheckBox(
                        SCConst.sitesIncluded,
                        1,
                        i,
                        0,
                        sitesStr[i],
                        i,
                        config,
                        this.onCheckboxChange,
                        this.onLabelClick
                    );

                    /* Makes arrow appear next to checkbox. */
                    const siteCheckBoxClone = React.cloneElement(
                        siteCheckBox,
                        { style: { display: "inline-block" } },
                        { key: "Site" + i }
                    );

                    sitesDivArray.push(<div>{siteCheckBoxClone}</div>);
                }
            }

            return (
                <div style={{ width: "33%", float: "left" }}>
                    <h5>Sites</h5>
                    {sitesDivArray}
                </div>
            );
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    render() {
        try {
            const config = this.props.config;
            const configExtra = this.props.configExtra;
            const siteInfo = this.props.siteInfo;

            const openProvCurrID = configExtra.openProvCurrID;
            const openSNU_CurrID = configExtra.openSNU_CurrID;

            const provincesDiv = this.createProvincesDiv();
            let SNUsDiv = null;
            let sitesDiv = null;

            if (openProvCurrID !== 0) {
                SNUsDiv = this.createSNUsDiv(openProvCurrID);

                if (openSNU_CurrID !== 0) {
                    if (hasSitesToDisplay(config, siteInfo, openProvCurrID, openSNU_CurrID)) {
                        sitesDiv = this.createSitesDiv(openProvCurrID, openSNU_CurrID);
                    } else {
                        sitesDiv = (
                            <div>
                                <h5>Sites</h5>
                                <p style={{ color: "red" }}>No sites available</p>
                            </div>
                        );
                    }
                }
            }

            if (config === null) {
                return null;
            }

            return (
                <div style={{ width: 900 }}>
                    {provincesDiv}
                    {SNUsDiv}
                    {sitesDiv}
                </div>
            );
        } catch (exception) {
            return (
                <div
                    className={"GBStartScreenFormDiv"}
                    key={"GBStartScreenFormDiv"}
                >
                    <h3 key={"GBStartScreenFormDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default SCLocationsSelector;
